var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningSm18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning-sm-18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 288 0 288 864 0 864"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18-&-24-Pixel-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(-384.000000, -320.000000)",
    stroke: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 121.5,
    y: 45.5,
    width: 311,
    height: 1012
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    transform: "translate(-240.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Duplicate-control"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "grid-18",
    mask: "url(#mask-2)",
    x: 240,
    y: 144,
    width: 18,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-240.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-sm-18",
    transform: "translate(240.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "grid-18",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99994044,10.5 C9.99994044,10.776 9.77594044,11 9.49994044,11 L8.49994044,11 C8.22394044,11 7.99994044,10.776 7.99994044,10.5 L7.99994044,7.5 C7.99994044,7.224 8.22394044,7 8.49994044,7 L9.49994044,7 C9.77594044,7 9.99994044,7.224 9.99994044,7.5 L9.99994044,10.5 Z M9.99994044,13.5 C9.99994044,13.776 9.77594044,14 9.49994044,14 L8.49994044,14 C8.22394044,14 7.99994044,13.776 7.99994044,13.5 L7.99994044,12.5 C7.99994044,12.224 8.22394044,12 8.49994044,12 L9.49994044,12 C9.77594044,12 9.99994044,12.224 9.99994044,12.5 L9.99994044,13.5 Z M15.9459404,15.275 L9.44494044,2.276 C9.26094044,1.908 8.73894044,1.908 8.55494044,2.276 L2.05394044,15.275 C1.88694044,15.607 2.12794044,16 2.49894044,16 L15.5009404,16 C15.8719404,16 16.1129404,15.607 15.9459404,15.275 Z",
    id: "icon",
    fill: "#6A7070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Slice",
    transform: "translate(-240.000000, -144.000000)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSm18);
export default __webpack_public_path__ + "static/media/warning-sm-18.1f09b6bd99ab6af8f5fcc723b632b7ab.svg";
export { ForwardRef as ReactComponent };